import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
const moment = moment_;
@Component({
  selector: 'axis-calendar-inner',
  template: `
    <div  #calendarInnerRef  tabindex="-1" *ngIf="datepickerMode"  role="application">
      <ng-content></ng-content>
      <axis-calendar-daypicker  #daypickerref  tabindex="0" ></axis-calendar-daypicker>
      <axis-calendar-monthpicker  #monthpickerref tabindex="-1"></axis-calendar-monthpicker>
      <axis-calendar-yearpicker #yearpickerref tabindex="-1"></axis-calendar-yearpicker>
    </div>
  `
})
export class CalendarInnerComponent implements OnInit, OnChanges {
  @Input() public browserLocale = false;
  @Input() public datepickerMode: string;

  @Input() public selectOnDay = false;
  @Input() public selectOnMonth = false;
  @Input() public selectOnYear = false;
  @Input() public modelDate: Date;
  @Input() public dateRange = false;
  @Input() public startDate;
  @Input() public endDate;

  public startingDay = 0;
  public focusedDate : Date;
  public yearRange = 20;
  public showWeeks = false;
  public minMode = 'day';
  public maxMode = 'year';
  public formatDay = 'D';
  public formatMonth = 'MMMM';
  public formatYear = 'YYYY';
  public formatDayHeader = 'dd';
  public formatDayTitle = 'MMMM YYYY';
  public formatMonthTitle = 'YYYY';
  public onlyCurrentMonth = false;
  public monthColLimit = 3;
  public yearColLimit = 5;
  public stepDay: any = {};
  public stepMonth: any = {};
  public stepYear: any = {};
  public modes: string[] = ['day', 'month', 'year'];
  public uniqueId: string;
  public _activeDate: Date;
  public selectedDate: Date;
  public activeDateId: string;
  public monthSelected = false;
  public yearSelected = false;
  public daySelected = false;
  public keyPressed = false;
  public localeLanguage: any;
  @Output()
  public selectionDone: EventEmitter<any> = new EventEmitter();
  @Output()
  public selectedRange: EventEmitter<any> = new EventEmitter();

  protected refreshViewHandlerDay: Function;
  protected compareHandlerDay: Function;
  protected refreshViewHandlerMonth: Function;
  protected compareHandlerMonth: Function;
  protected refreshViewHandlerYear: Function;
  protected compareHandlerYear: Function;

  @ViewChild('calendarInnerRef') calendarInnerRef: any;
  @ViewChild('daypickerref') daypickerref: any;
  @ViewChild('monthpickerref') monthpickerref: any;
  @ViewChild('yearpickerref') yearpickerref: any;
  @Input()
  public get activeDate(): Date {
    return this._activeDate;
  }

  public set activeDate(value: Date) {
    this._activeDate = value;
  }

  // todo: add formatter value to Date object
  public ngOnInit(): void {
    // todo: use date for unique value
    this.uniqueId = 'calendar-' + '-' + Math.floor(Math.random() * 10000);
    if (this.modelDate) {
      this.activeDate = this.modelDate;
      this.selectedDate = new Date(this.activeDate.valueOf());
    } else if (this.activeDate === undefined) {
      this.activeDate = new Date();
    }
  }
  constructor(public el: ElementRef) { }

  // this.refreshView should be called here to reflect the changes on the fly
  // tslint:disable-next-line:no-unused-variable
  public ngOnChanges(changes: SimpleChanges): void {
    this.refreshView();
  }



  public setCompareHandler(handler: Function, type: string): void {
    if (type === 'day') {
      this.compareHandlerDay = handler;
    }

    if (type === 'month') {
      this.compareHandlerMonth = handler;
    }

    if (type === 'year') {
      this.compareHandlerYear = handler;
    }
  }

  public compare(date1: Date, date2: Date): number | undefined {
    if (date1 === undefined || date2 === undefined) {
      return undefined;
    }

    if (this.datepickerMode === 'day' && this.compareHandlerDay) {
      return this.compareHandlerDay(date1, date2);
    }

    if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
      return this.compareHandlerMonth(date1, date2);
    }

    if (this.datepickerMode === 'year' && this.compareHandlerYear) {
      return this.compareHandlerYear(date1, date2);
    }
    return void 0;
  }

  public setRefreshViewHandler(handler: Function, type: string): void {
    if (type === 'day') {
      this.refreshViewHandlerDay = handler;
    }

    if (type === 'month') {
      this.refreshViewHandlerMonth = handler;
    }

    if (type === 'year') {
      this.refreshViewHandlerYear = handler;
    }
  }

  public refreshView(): void {
    if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
      this.refreshViewHandlerDay();
    }

    if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
      this.refreshViewHandlerMonth();
    }

    if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
      this.refreshViewHandlerYear();
    }
  }

  public dateFilter(date: Date, format: string): string {
    return moment(date.getTime()).format(format);
  }

  public isActive(dateObject: any): boolean {
    if (this.compare(dateObject.date, this.activeDate) === 0) {
      this.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  }

  public createDateObject(date: Date, format: string): any {
    const dateObject: any = {};
    dateObject.date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    dateObject.label = this.dateFilter(date, format);
    if (this.dateRange) {
      if (this.startDate) {
        dateObject.startDate = this.compare(date, this.startDate) === 0;
      }
      if (this.endDate) {
        dateObject.endDate = this.compare(date, this.endDate) === 0;
      }
      if (this.startDate && this.endDate) {
        dateObject.disabled = this.isDisabled(date);
      }
    } else {
      dateObject.selected = this.compare(date, this.selectedDate) === 0;
    }
    dateObject.focused = this.compare(date, this.focusedDate) === 0;
    dateObject.current = this.compare(date, new Date()) === 0;
    return dateObject;
  }
  protected isDisabled(date: Date): boolean {
    if (this.datepickerMode === 'day') {
      if (date > this.startDate && this.endDate > date) {
        return true;
      }
    } else if (this.datepickerMode === 'month') {
      const setEndMonth = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), 1);
      if (date > this.startDate && setEndMonth > date) {
        return true;
      }
    }
  }

  public split(arr: any[], size: number): any[] {
    const arrays: any[] = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  }

  public fixTimeZone(date: Date): Date {
    const hours = date.getHours();
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours === 23 ? hours + 2 : 0
    );
  }

  rangeSelection(activeDate) {
    if (this.startDate && this.endDate) {
      if (this.startDate.getTime() === this.endDate.getTime()) {
        if (activeDate > this.startDate) {
          this.endDate = activeDate;
        } else {
          this.startDate = activeDate;
          this.endDate = null;
        }
      } else {
      this.startDate = activeDate;
      this.endDate = null;
      }
      if (this.datepickerMode === 'day') {
        this.refreshViewHandlerDay();
      } else if (this.datepickerMode === 'month') {
        this.refreshViewHandlerMonth();
      }
    } else {
      this.startDate = this.selectedDate ? this.selectedDate : activeDate;
      if (activeDate > this.startDate) {
        this.endDate = activeDate;
      } else if (this.startDate > activeDate) {
        this.endDate = null;
        this.startDate = activeDate;
      }
      if (this.endDate) {
        if (this.datepickerMode === 'day') {
          this.refreshViewHandlerDay();
        } else if (this.datepickerMode === 'month') {
          this.refreshViewHandlerMonth();
        }
      }
    }
  }
  public select(date: Date, isManual: boolean = true): void {
    this.keyPressed = true;
    if (this.selectOnDay && this.datepickerMode === 'day') {
      this.daySelected = true;
      this.monthSelected = false;
      this.yearSelected = false;
      if (!this.activeDate) {
        this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
      }

      this.activeDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      if (this.dateRange) {
        this.focusedDate = date;
        this.rangeSelection(this.activeDate);
      }
      if (this.startDate || this.endDate) {
        this.selectedRange.emit({
          'startDate': this.startDate,
          'endDate': this.endDate
        });
      }
      if (isManual) {
        this.selectionDone.emit(this.activeDate);
      }
    } else if (this.selectOnMonth && this.datepickerMode === 'month') {
      this.monthSelected = true;
      this.daySelected = false;
      this.yearSelected = false;
      this.activeDate = new Date(
        date.getFullYear(),
        date.getMonth() + 1, 0
      );
      if (isManual) {
        const selectedMonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(this.activeDate);
        this.selectionDone.emit(selectedMonth + ' ' + this.activeDate.getFullYear());
      }
      if (this.dateRange) {
        this.rangeSelection(this.activeDate);
        if (this.startDate || this.endDate) {
          this.selectedRange.emit({
            'startDate': this.startDate,
            'endDate': this.endDate
          });
        }
      }
    } else if (this.selectOnYear && this.datepickerMode === 'year') {
      this.yearSelected = true;
      this.monthSelected = false;
      this.daySelected = false;
      this.activeDate = new Date(date.getFullYear(), 0, 1);
      if (isManual) {
        this.selectionDone.emit(this.activeDate.getFullYear());
      }
    } else {
      this.monthSelected = false;
      this.yearSelected = false;
      this.daySelected = false;
      this.activeDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      if (isManual) {
        this.datepickerMode = this.modes[
          this.modes.indexOf(this.datepickerMode) - 1
        ];
      }
    }
    if (this.daySelected || this.monthSelected || this.yearSelected) {
      this.selectedDate = new Date(this.activeDate.valueOf());
    }
    this.refreshView();
  }

  public move(direction: number): void {
    let expectedStep: any;
    if (this.datepickerMode === 'day') {
      expectedStep = this.stepDay;
    }

    if (this.datepickerMode === 'month') {
      expectedStep = this.stepMonth;
    }

    if (this.datepickerMode === 'year') {
      expectedStep = this.stepYear;
    }

    if (expectedStep) {
      const year =
        this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
      const month =
        this.activeDate.getMonth() + direction * (expectedStep.months || 0);
      this.activeDate = new Date(year, month, 1);

      this.refreshView();
    }
  }

  public toggleMode(direction?: number): void {
    if (direction === 0) {
      direction = 0;
    } else {
      direction = direction || 1;
    }
    if (
      (this.datepickerMode === this.maxMode && direction === 1) ||
      (this.datepickerMode === this.minMode && direction === -1)
    ) {
      return;
    }
    this.datepickerMode = this.modes[
      this.modes.indexOf(this.datepickerMode) + direction
    ];
    this.refreshView();
  }


  @HostListener('keydown', ['$event', 'this.calendarInnerRef'])
  onKeydown(e: any, calendarInnerRef: any) {
    if(!this.dateRange) {
    e.preventDefault();
    if (this.datepickerMode === 'day') {
      this.calendarInnerRef.nativeElement.childNodes[0].focus();
      this.calendarInnerRef.nativeElement.childNodes[0].style.outline = 'none';
    } else if (this.datepickerMode === 'month') {
      this.calendarInnerRef.nativeElement.childNodes[1].focus();
      this.calendarInnerRef.nativeElement.childNodes[1].style.outline = 'none';
    } else if (this.datepickerMode === 'year') {
      this.calendarInnerRef.nativeElement.childNodes[2].focus();
      this.calendarInnerRef.nativeElement.childNodes[2].style.outline = 'none';
    }
  }
  }

  @HostListener('click', ['$event', 'this.calendarInnerRef'])
  onClick(e: any, calendarInnerRef: any) {
    this.keyPressed = true;
    e.preventDefault();
    if (this.datepickerMode === 'day') {
      this.calendarInnerRef.nativeElement.childNodes[0].focus();
      this.calendarInnerRef.nativeElement.childNodes[0].style.outline = 'none';
    } else if (this.datepickerMode === 'month') {
      this.calendarInnerRef.nativeElement.childNodes[1].focus();
      this.calendarInnerRef.nativeElement.childNodes[1].style.outline = 'none';
    } else if (this.datepickerMode === 'year') {
      this.calendarInnerRef.nativeElement.childNodes[2].focus();
      this.calendarInnerRef.nativeElement.childNodes[2].style.outline = 'none';
    }
  }

}
